"use client";

import { Button } from "@/components/ui/button";
import React, { useEffect, useState } from "react";
import { sectionVariants, SpacingType } from "@/types";
import Image from '@/components/ui/Image';
import { Card, CardContent, CardFooter } from "@/components/ui/card";

import parse from "html-react-parser";
import Link from "next/link";
import { SectionWrapper } from "../components/SectionWraper";
import { Carousel, CarouselApi, CarouselContent, CarouselItem } from "../ui/carousel";

interface Testimonial {
  image?: string;
  imageAltText?: string;
  content?: string;
  author?: string;
  company?: string;
  link?: string;
  linkText?: string;
  initials?: string;
}
interface Testimonial3Props {
  darkMode?: boolean;
  spacing?: SpacingType;
  variant?: sectionVariants;
  usedInPageNav?: boolean;
  pageNavTitle?: string;
  themeChangeOnScroll?: boolean;
  title?: string;
  testimonials  ?: [];
  attributes?: React.HTMLProps<HTMLElement>;
}

const TestimonialCard = ({item}: {item: Testimonial}) => {
  return (
    <Card className="border-brand">
      {item.content && (
        <CardContent className="p-0 flex-1 paragraph-base text-muted-foreground">
          {parse(item.content)}
        </CardContent>
      )}
      <CardFooter className="p-0">
        <div className="flex gap-4 flex-1 items-center">
          {item.image && !item.initials && (
            <Image
              src={item.image}
              alt={item.imageAltText ?? ""}
              title={item.imageAltText ?? ""}
              width={600}
              height={600}
              className="w-12 h-12 rounded-full object-cover"
            />
          )}
          {item.initials && (
            <div className="w-12 h-12 rounded-full bg-brand flex items-center justify-center">
              <p className="text-white font-bold paragraph-lg !p-0">{item.initials}</p>
            </div>
          )}
          {item.author && (
            <div className="flex flex-col paragraph-lg flex-1">
              <p className="font-bold">{item.author}</p>
              {item.company && (
                <p className="text-muted-foreground">{item.company}</p>
              )}
            </div>
          )}
          {item.link && (
            <Button asChild variant="outline" lifted grayBorder size="iconLg">
              <Link href={item.link}>
                <span className="material-symbols-outlined">arrow_forward</span>
              </Link>
            </Button>
          )}
        </div>
      </CardFooter>
    </Card>
  )
}

const Testimonial3 = ({
  // darkMode = true,
  spacing = 'xlarge',
  variant = 'A',
  usedInPageNav = false,
  pageNavTitle = "Testimonial 3",
  themeChangeOnScroll = false,
  title,
  testimonials,
  attributes,
}: Testimonial3Props) => {

  const [api, setApi] = useState<CarouselApi>();
  // const [current, setCurrent] = useState(0);

  useEffect(() => {
    if (!api) {
      return;
    }

    // api.on("select", () => {
    //   setCurrent(api.selectedScrollSnap());
    // });
  }, [api]);

  return (
    <SectionWrapper
      usedInPageNav={usedInPageNav}
      pageNavTitle={pageNavTitle}
      themeChangeOnScroll={themeChangeOnScroll}
      spacing={spacing}
      variant={variant}
      darkMode={true}
      heroSection={false}
      componentName="testimonial3"
      attributes={attributes}
      className="!py-10"
    > 
      <div className="container" data-aos="fade-up">
        <div className="mb-8">
          <div>
            {title && (
              <h3>
                {parse(title)}
              </h3>
            )}
          </div>
        </div>
        <Carousel
          opts={{
            align: "center",
            loop: true,
          }}
          setApi={setApi}
        >
          <CarouselContent>
            {testimonials?.map((item, index) => (
              <CarouselItem key={index} className="pl-6 pr-2">
                <TestimonialCard item={item} />
              </CarouselItem>
            ))}
          </CarouselContent>
        </Carousel>
        {(testimonials && testimonials.length > 1) && (
          <div className="mt-8 flex shrink-0 items-center justify-start gap-2">
            <Button
              size="iconSm"
              variant="outline"
              grayBorder
              onClick={() => {
                api?.scrollPrev();
              }}
              disabled={!api?.canScrollPrev}
              className="disabled:pointer-events-auto"
            >
              <span className="material-symbols-outlined">
                arrow_back  
              </span>
            </Button>
            <Button
              size="iconSm"
              variant="outline"
              grayBorder
              onClick={() => {
                api?.scrollNext();
              }}
              disabled={!api?.canScrollNext}
              className="disabled:pointer-events-auto"
            >
              <span className="material-symbols-outlined">
                arrow_forward
              </span>
            </Button>
          </div>
        )}
      </div>
    </SectionWrapper>
  );
};

export { Testimonial3 };
